import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'
import { DatePicker } from '../../../atoms'

const { RangePicker } = DatePicker

interface DropdownRangePicker {
  name: string
  onFilterChange: (s: string, v: any) => void
  value: string
}

const DropdownRangeSelector: React.ComponentType<DropdownRangePicker> = ({
  name,
  onFilterChange,
  value = ''
}) => {
  const [date, setDate] = useState<[Date, Date] | null | undefined>()

  useEffect(() => {
    if (value) {
      const dates = value.split('-')
      if (dates[0] && dates[1]) {
        const from = new Date(dates[0])
        const to = new Date(dates[1])
        setDate([from, to])
      }
    } else {
      setDate(null)
    }
  }, [value])
  // set filter values as `dd/MM/yyyy-dd/MM/yyyy`
  const applyFilter = (range: Date[] | null): void => {
    if (range) {
      onFilterChange(
        name,
        `${format(range[0], 'MM/dd/yyyy')}-${format(range[1], 'MM/dd/yyyy')}`
      )
    } else onFilterChange(name, null)
  }

  return (
    <RangePicker
      onChange={(range: any): void => applyFilter(range)}
      format="dd-MM-yyyy"
      value={date}
      getPopupContainer={(trigger): HTMLElement => trigger}
    />
  )
}

export default DropdownRangeSelector
